import React from "react";
import assetify from "@quintype/framework/assetify";

import "./features.m.css";
import { FEATURES } from "../constants";

export const Features = () => {
  return (
    <div styleName="wrapper" className="full-width">
      <h2 styleName="section-title">Why should you subscribe?</h2>
      <div styleName="features-wrapper">
        {FEATURES.map((item, index) => {
          return (
            <div styleName="feature" key={index}>
              {index % 2 === 0 ? (
                <>
                  <img src={assetify(item.imgSrc)} alt={item.title} />
                  <div styleName="text-wrapper">
                    <h2>{item.title}</h2>
                    <p>{item.description}</p>
                  </div>
                </>
              ) : (
                <>
                  <div styleName="text-wrapper">
                    <h2>{item.title}</h2>
                    <p>{item.description}</p>
                  </div>
                  <img src={assetify(item.imgSrc)} alt={item.title} />
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
